"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useRevealOnScroll from "../../hooks/useRevealOnScroll";
import "./FooterCTASection.css";
import { ROUTES } from "../../../routes/patientRoutes/routePaths";
import { DOCTOR_ROUTES } from "../../../routes/patientRoutes/routePaths";

export default function FooterCTASection() {
  const navigate = useNavigate();
  const { t } = useTranslation("landingPage");

  useRevealOnScroll();

  return (
    <>
      <section className="footer-cta" id="cta">
        <div className="footer-cta__container reveal-on-scroll reveal-scale">
          <h2 className="footer-cta__title">
            {t("footerCta.title.line1")}
            <br />
            {t("footerCta.title.line2")}
          </h2>

          <p className="footer-cta__subtitle">{t("footerCta.subtitle")}</p>

          <div className="footer-cta__actions">
            <button
              className="footer-cta__btn footer-cta__btn--light"
              type="button"
              onClick={() => navigate(ROUTES.LOGIN)}
            >
              {t("common.patient")}
              <span className="footer-cta__arrow">↗</span>
            </button>

            <button
              className="footer-cta__btn footer-cta__btn--dark"
              type="button"
              onClick={() => navigate(DOCTOR_ROUTES.LOGIN)}
            >
              {t("common.doctor")}
              <span className="footer-cta__arrow">↗</span>
            </button>
          </div>

          <p className="footer-cta__small">{t("footerCta.small")}</p>
        </div>
      </section>

      <footer className="footer-bottom">
        <div className="footer-bottom__brand">
          Medilink <span>{t("footerBottom.brand")}</span>
        </div>

        <p className="footer-bottom__copy">{t("footerBottom.copy")}</p>
      </footer>
    </>
  );
}